var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { EditGroupMembersContent } from '../../../../../../ui/features/classifiers-admin-pages/components/CustomFields/components/EditGroupMembersDialog';
import { useGroupsWithCustomFieldsTable } from '../../../../../../ui/features/classifiers-admin-pages/components/CustomFields/hooks/useGroupsWithCustomFieldsTable';
import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { DataTable, TextCell } from '@juvare/common-data-table-ui/DataTable';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
export function showGroupsWithCustomFieldsDialog(customFieldName) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'sm',
        onEscapeKeyDown: (close) => {
            close();
        },
        content: (close, ariaTitleId, ariaContentId) => {
            return (React.createElement(GroupsWithCustomFieldsDialogContent, { customFieldName: customFieldName, ariaTitleId: ariaTitleId, ariaContentId: ariaContentId, close: close }));
        },
    });
}
const GroupsWithCustomFieldsDialogContent = (props) => {
    const { t } = useContactManagementTranslation();
    const { dataTableProps, reload } = useGroupsWithCustomFieldsTable(props.customFieldName);
    const columns = [
        {
            headerLabel: t('panels.groups.entity'),
            cellFunction: (row) => React.createElement(TextCell, null, row.groupName),
        },
        {
            headerLabel: t('common.owner'),
            cellFunction: (row) => React.createElement(TextCell, null, row.groupOwner),
        },
        {
            cellFunction: (row) => {
                return (React.createElement(Button, { variant: 'outlined', "data-test": 'edit-group-button', onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        showCustomDialog({
                            fullScreen: true,
                            content: (close) => (React.createElement(EditGroupMembersContent, { groupId: row.id, close: () => {
                                    close();
                                    reload();
                                } })),
                        });
                    }) }, t('common.edit')));
            },
            tableCellBodySx: {
                width: 124,
            },
        },
    ];
    return (React.createElement(Box, null,
        React.createElement(DialogTitle, { id: props.ariaTitleId }, t('rules.customFieldDeleteHeader')),
        React.createElement(DialogContent, { id: props.ariaContentId },
            React.createElement(Typography, { sx: { mb: 1 } }, t('rules.customFieldIsUsed')),
            React.createElement(DataTable, Object.assign({}, dataTableProps, { columns: columns }))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', onClick: () => props.close(), "data-test": 'ok-button' }, t('common.ok')))));
};
